import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BlogDetailsApi } from "../../api/blog";
import { Spin } from "antd";
import dayjs from "dayjs";

const BlogDetail = () => {
  const { id } = useParams();
  const [blogDetails, setBlogDetails] = useState(null);
  const [isBlogLoading, setIsBlogLoading] = useState(false);

  const GetBlogDetails = async () => {
    try {
      setIsBlogLoading(true);
      const { data } = await BlogDetailsApi({ id });
      if (data?.status) {
        setBlogDetails(data?.data);
      }
      setIsBlogLoading(false);
    } catch (error) {
    } finally {
      setIsBlogLoading(false);
    }
  };

  useEffect(() => {
    GetBlogDetails();
  }, [id]);

  return (
    <>
      <div className="website-container my-10">
        <Spin spinning={isBlogLoading} size="large">
          {blogDetails ? (
            <div className="mx-auto">
              <div>
                <h2 className="xl:text-4xl md:text-3xl sm:text-xl font-bold mb-2">
                  {blogDetails?.title}
                </h2>
                <p className="text-gray-600 xl:text-[18px] md:text-[16px] sm:text-[14px]">
                  {dayjs(blogDetails?.date).format("MMMM D, YYYY")}
                </p>
              </div>
              <div>
                <img
                  src={blogDetails?.image}
                  alt={blogDetails?.title}
                  className="w-full h-[700px] object-cover rounded"
                />
              </div>
              <div
                className="bg-gray-100 p-6"
                dangerouslySetInnerHTML={{ __html: blogDetails?.desc }}
              />
            </div>
          ) : (
            <p className="text-center">No Blog Found</p>
          )}
        </Spin>
      </div>
    </>
  );
};

export default BlogDetail;
